module.exports = __webpack_public_path__ + "img/AuctionEndingSoonIcon.b9beaa5e.svg";